import React from 'react';
import Skeleton from '@mui/material/Skeleton';

const WelcomeHeaderSkeleton = () => (
  <div
    data-testid="welcome-header-skeleton"
    style={{
      display: 'flex',
      alignItems: 'center',
    }}
  >
    <Skeleton variant="circular" width={48} height={48} sx={{ marginRight: '10px' }} />
    <Skeleton variant="rectangular" width="50%" height={48} />
  </div>
);

export default WelcomeHeaderSkeleton;
